import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../components/Intl/WithIntl';
import { Container, Row, Col, Card, CardHeader, CardTitle, CardBody, CardImg, CardImgOverlay, Jumbotron, ButtonGroup, Button, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PageWrapper from '../../../components/Content/PageWrapper';
import AppLogo from '../../App/components/view/AppLogo';

function ErrorPage(props) {
    return (
        <Container className="page-wrapper mt-5 bg-company text-center">
            <PageWrapper>
                <AppLogo suffix="alt" />
                <Card className="mt-5 mb-5 shadow text-center">
                    <CardHeader>
                        <CardTitle>
                            <FontAwesomeIcon icon="exclamation-triangle" /> <FormattedMessage id="appBackHomeTitle" defaultMessage="Wrong Way..." />
                        </CardTitle>
                    </CardHeader>
                    <CardBody className="px-3">
                        <FormattedMessage id="app404ErrorText" defaultMessage="We didn't find what you're looking for! Go back to homepage or your account" />
                        <ButtonGroup className="d-block mt-3">
                            <Button tag="a" href="/" color="secondary" outline><FontAwesomeIcon icon="chevron-left" /> <FormattedMessage id="appBackHomeButton" defaultMessage="Back home" /></Button>
                            <Button tag="a" href="/user/profile" color="primary" outline><FontAwesomeIcon icon="user-circle" /> <FormattedMessage id="userAccountMy" defaultMessage="My account" /></Button>
                        </ButtonGroup>
                    </CardBody>
                </Card>
            </PageWrapper>
        </Container>
    );
}

ErrorPage.propTypes = {
    intl: PropTypes.object.isRequired,
};

export default withIntl(ErrorPage);
